import {StyledButton, StyledErrorIcon, StyledAlertErrorBox, StyledAlert, StyledSnackbar} from './SnackbarStyle'
import IconButton from '@mui/material/IconButton'
import Collapse from '@mui/material/Collapse'
import CloseIcon from '@mui/icons-material/Close'
import buttonTitles from '../../../appConfig/buttonTitles.config.json'

const SnackbarComponent = ({showNotification, setShowNotification, message, error, tryAgain, isCreateUser}) => {
  const handleSnackbarClosed = () => {
    setShowNotification(false)
  }

  const check = false
  const errorAlert = () => {
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap'}}>
        <StyledAlertErrorBox showNotification={showNotification} iscreateuser={isCreateUser}>
          <Collapse in={showNotification}>
            <StyledAlert
              variant='error'
              severity='error'
              icon={<StyledErrorIcon />}
              action={
                <IconButton
                  aria-label='close'
                  color='inherit'
                  size='small'
                  onClick={() => {
                    setShowNotification(false)
                  }}
                  title={buttonTitles.snackbarFailureAlert}
                >
                  <CloseIcon fontSize='inherit' />
                </IconButton>
              }
            >
              {message}
              {tryAgain !== undefined || tryAgain !== check ? tryAgain : false}
            </StyledAlert>
          </Collapse>
        </StyledAlertErrorBox>
      </div>
    )
  }

  const successSnackbar = () => {
    return (
      <StyledSnackbar
        anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        open={showNotification}
        autoHideDuration={2000}
        onClose={handleSnackbarClosed}
      >
        <StyledButton aria-label={message} role='alert'>
          {message}
        </StyledButton>
      </StyledSnackbar>
    )
  }

  return error ? errorAlert() : successSnackbar()
}

export default SnackbarComponent
